<form #form="ngForm" (ngSubmit)="captcha.submit()"
      autocomplete="off">

  <div class="row">
    <div class="col-24">

      <!-- -->
      <div class="sts-object">

        <ng-container *ngFor="let h of questions; let i = index">

          <div class="sts-label-row">
            <label [attr.for]="'q'+h.questionID">
              {{h.questionDescription}}
            </label>
          </div>
          <div class="sts-input-row">
            <input type="text"
                   [attr.id]="'q'+h.questionID"
                   app-sts-regex-input
                   [name]="'q'+h.questionID"
                   [model]="getReType(h)"
                   class="sts-textbox"
                   [(ngModel)]="registrationModel.answers[i].answer"
                   [(validateEventHook)]="triggerValidateEmitter"
                   (onValidate)="checkValidate($event)"
                   aria-required="true"/>
            <div *ngIf="states[h.questionID]" role="alert">
              <small class="sts-inline-error">
                {{ states[h.questionID] }}
              </small>
            </div>
          </div>

        </ng-container>
        <div style="margin-bottom: 10px; padding-top: 10px;">
          <app-sts-captcha (onValidate)="onSubmit($event)"></app-sts-captcha>
        </div>

      </div>
      <!-- -->

      <!-- -->
      <div class="sts-object">
        <button app-sts-cms-txt key="sts-cancel-button"
                class="sts-btn other-sts-btn"
                type="button"
                (click)="cancel()">
          Cancel
        </button>
        <app-sts-button [submit]="submitter" key="sts-next-button">
          Next
        </app-sts-button>
      </div>
      <!-- -->

    </div>
  </div>

</form>
